import { render, staticRenderFns } from "./BanModal.vue?vue&type=template&id=14dc23a5&scoped=true&"
import script from "./BanModal.vue?vue&type=script&lang=js&"
export * from "./BanModal.vue?vue&type=script&lang=js&"
import style0 from "./BanModal.vue?vue&type=style&index=0&id=14dc23a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dc23a5",
  null
  
)

export default component.exports